import React, {Component} from 'react';
import {connect} from 'react-redux';
import Login from '../../components/Login/Login';
import LoginClass from '../../shared/loginClass/LoginClass';
import { ToastContainer, toast } from 'react-toastify';
import {  Redirect, withRouter } from 'react-router-dom';
//actions
import {
    setUserLogout,
    fetchUser,
    cleanLoginErrors,
} from '../../store/actions/userActions';
import { resetPassword } from '../../store/actions/userActions';

class LoginContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoggingOut: false,
            redirectToReferrer: false,
            loginAfterVerify: false,
        };

        this.cognitoAuth = new LoginClass();
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.error && nextProps.error !== '200' && nextProps.error.message ) {
          if(nextProps.error.message === 'PostAuthentication failed with error 408.'){
            toast.error('Your Trial Period of 14 days have been passed, process with the activation of your account for continuing using the toolkit.');
          }else{
            toast.error(nextProps.error.message);
          }
          setTimeout(() => this.props.dispatch(cleanLoginErrors()), 5000);
          return;
      }
    }

    componentWillMount() {
        this._stylesheetPromises = [];

        window.localStorage.removeItem('flightTabFormData');
        window.localStorage.removeItem('flightTabError');
        window.localStorage.removeItem('currentTab');
    }

    componentWillUnmount() {
        this._stylesheetPromises.forEach(function (p) {
            p.then(function (link) {
                if (link.parentNode) link.parentNode.removeChild(link);
            });
        });
    }

    componentDidUpdate(prevProps) {
        const isLoggingOut = prevProps.isLoggedIn && !this.props.isLoggedIn;
        const isLoggingIn = !prevProps.isLoggedIn && this.props.isLoggedIn;
        if (isLoggingIn) {
            const { user } = this.props;
        }
        if (isLoggingOut) {
            clearInterval(this.getUserTokeInterval);
            this.setState({isLoggingOut: true});
            setTimeout(() => {
                this.setState({isLoggingOut: false});
            }, 3000);
        }
    }

    getToken() {
        this.cognitoUtil.getIdTokenPromise()
          .then((item) => {
            this.token = item;
          });
      }

    loadStyleSheet(name, url) {
        this._stylesheetPromises.push(loadStyleSheet(url))
    }

    handleLoginUser = (params) => {
      const {dispatch, currentURL} = this.props;
      dispatch(fetchUser(params, this.cognitoAuth));
    }

    onForgotPasswordConfirm = (data) => {
        this.props.dispatch(resetPassword(data, this.cognitoAuth));
    }

    // for logout we use direct logout container
    handleLogout() {
        this.props.dispatch(setUserLogout());
    }

    redirectToAdmin() {
      const token = localStorage.getItem('userToken');
      const refreshToken = localStorage.getItem('user');
      let returnVal = token || refreshToken || this.props.isLoggedIn;
      return returnVal;
    }

    render() {
      const { from } = this.props.location.state || { from: { pathname: '/' } }
      const { redirectToReferrer } = this.state;

      if (this.redirectToAdmin()) {
        return <Redirect to={{ pathname: '/toolkit' }} />
      }

      return(
        <div>
            <div className="error-box">
              <ToastContainer
                position="top-right"
                type="success"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                pauseOnHover
              />
            </div>
            <Login
                onLogout={this.handleLogout.bind(this)}
                user={this.props.user}
                isLoggedIn={this.props.isLoggedIn}
                isConfirmed={this.props.isConfirmed}
                isUnconfirmed={this.props.isUnconfirmed}
                isNew={this.props.isNew}
                email={this.props.email}
                onLoginUser={this.handleLoginUser}
                loginFetched={this.props.loginFetched}
                loginFetching={this.props.loginFetching}
                error={this.props.error}
                loginAfterVerify={this.state.loginAfterVerify}
                //loginPathName={this.props.children.props.location.pathname}
                ressetPass={this.props.ressetPass}
                onForgotPasswordConfirm={this.onForgotPasswordConfirm}
            />
        </div>
      )
    }
}

function loadStyleSheet(url) {
    let main = document.getElementById('main-style');
    main.href = url;
}

function MapStateToProps(state, ownProps) {
  return {
      user: state.user.user,
      isLoggedIn: state.user.isLoggedIn,
      email: state.user.user ? state.user.user.email : null,
      loginFetching: state.user.loginFetching,
      loginFetched: state.user.loginFetched,
      error: state.user.error,
      ressetPass: state.user.ressetPass
  };
}

export default withRouter(connect(MapStateToProps)(LoginContainer));



// WEBPACK FOOTER //
// ./src/containers/Login/LoginContainer.js